import FlickityI from 'flickity';
import 'flickity-fade';

function ArticlesCarousel({ node }) {
	const options = {
		wrapAround: true,
		dots: true,
		autoPlay: 6000,
		prevNextButtons: false,
		fade: true,
	};

	// if (node?.dataset?.options) {
	// 	options = Object.assign(options, JSON.parse(node.dataset.options));
	// }

	// const instance = new FlickityI(node, options);

	const carousel = new FlickityI(node, options);

	// return () => {
	// 	carousel.destroy();
	// };

	carousel.resize();
}

export default ArticlesCarousel;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
